import React from "react";
import { Table } from "antd";
import AntdTableScrollXaxisTop from "antd-table-scroll-xaxis-top";

import styles from "./TabelaRelatorioAluno.module.scss";

const gerarColunas = avaliacoes => {
    const colunasAvaliacao = avaliacoes.map((av, idx) => ({
        title: av.nome,
        dataIndex: `avaliacao_${idx}`,
        key: `avaliacao_${idx}`,
        align: "center",
        width: 120
    }));

    return [
        ...colunasAvaliacao,
        {
            title: "Estado",
            dataIndex: "estado",
            key: "estado",
            align: "center",
            width: 120
        }
    ];
};

const transformarParaDataSource = avaliacoes => {
    const row = { key: 0 };
    let statusFinal = "APROVADO";

    avaliacoes.forEach((av, idx) => {
        const key = `avaliacao_${idx}`;
        const nota = av.nota;
        const notaNumerica = parseFloat(nota?.replace(",", "."));

        const isNotaInvalida = nota === null || nota === "" || isNaN(notaNumerica);

        // Checar se está reprovado
        if (isNotaInvalida || notaNumerica < 6) {
            statusFinal = "REPROVADO";
        }

        const isMedia = av.nome === "Média Bimestral" || av.nome === "Média Anual";

        row[key] = (
            <div className={isMedia ? (notaNumerica >= 6 ? "marca-aluno-aprovado" : "marca-aluno-reprovado") : ""}>
                {isNotaInvalida ? "-" : nota}
            </div>
        );
    });

    row.estado =
        statusFinal === "APROVADO" ? (
            <div className="marca-aluno-aprovado">Aprovado</div>
        ) : (
            <div className="marca-aluno-reprovado">Reprovado</div>
        );

    return [row];
};

const TabelaRelatorioAluno = ({ disciplinas }) => {
    if (!disciplinas || disciplinas.length === 0) return null;

    return (
        <>
            {disciplinas.map((disciplina, index) => {
                const colunas = gerarColunas(disciplina.avaliacoes);
                const dataSource = transformarParaDataSource(disciplina.avaliacoes);

                return (
                    <div key={index} className={styles.disciplina}>
                        <h2>{disciplina.disciplina}</h2>
                        <AntdTableScrollXaxisTop>
                            <Table
                                className={styles.tabela}
                                columns={colunas}
                                dataSource={dataSource}
                                bordered
                                pagination={false}
                                scroll={{ x: 1000 }}
                            />
                        </AntdTableScrollXaxisTop>
                    </div>
                );
            })}
        </>
    );
};

export default TabelaRelatorioAluno;
